import React from "react";
import Link from "next/link";

interface ContainerProps {
  buttonText?: string;
  buttonLink?: string;
  innerDivs?: { title: string; description: string; link?: string }[];
  containerTitle?: string;
  containerSubtitle?: string;
  containerLink?: string;
}

interface ServiceOverviewProps {
  title: string;
  subtitle: string;
  containers: ContainerProps[];
  id?: string;
}

const ServiceOverview: React.FC<ServiceOverviewProps> = ({
  title,
  subtitle,
  containers,
  id,
}) => {
  return (
    <div id={id} className="flex flex-col items-center gap-6 md:px-4 py-12">
      <div className="text-center gap-6 flex flex-col">
        <h3>{title}</h3>
        <p className="max-w-[1300px]">{subtitle}</p>
      </div>

      <div className="flex flex-col sm:flex-row justify-center w-full items-start gap-4 md:gap-12">
        <div className="flex flex-col gap-8 2xl:p-6 w-full max-w-[250px] lg:max-w-[350px]">
          <div className="flex flex-col gap-2">
            <Link
              className="subtitle text-[#3b82f6]"
              href={containers[0]?.containerLink || "/"}
            >
              <p className="subtitle text-[#3b82f6] underline">
                {containers[0]?.containerTitle || title}
              </p>
            </Link>

            <p>{containers[0]?.containerSubtitle || subtitle}</p>
          </div>

          {containers[0]?.buttonText && containers[0]?.buttonLink && (
            <a
              href={containers[0]?.buttonLink}
              className="text-center hidden md:block py-2 px-4 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300"
            >
              {containers[0]?.buttonText}
            </a>
          )}
        </div>

        <div className="flex flex-col gap-8 w-full sm:w-auto">
          {containers.slice(1, 3).map((container, index) => (
            <div key={index + 1} className="flex flex-col gap-8 2xl:p-6 w-full">
              {container.innerDivs ? (
                <div className="flex flex-col gap-4 ">
                  <div className="flex flex-col md:flex-row justify-between gap-6">
                    {container.innerDivs.map((div, divIndex) => (
                      <div
                        key={divIndex}
                        className="flex flex-col gap-2 w-full md:max-w-[350px]"
                      >
                        <Link
                          className="subtitle text-[#3b82f6]"
                          href={div.link || "/"}
                        >
                          <p className="subtitle text-[#3b82f6] underline">
                            {div.title}
                          </p>
                        </Link>
                        <p>{div.description}</p>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col gap-2">
                  <p className="subtitle">
                    {container.containerTitle || title}
                  </p>
                  <p className="text-gray-400">
                    {container.containerSubtitle || subtitle}
                  </p>
                </div>
              )}

              {container.buttonText && container.buttonLink && (
                <a
                  href={container.buttonLink}
                  className="text-center py-2 px-4 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300"
                >
                  {container.buttonText}
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
      {containers[0]?.buttonText && containers[0]?.buttonLink && (
        <a
          href={containers[0]?.buttonLink}
          className="text-center md:hidden py-2 px-4 rounded-full border border-blue-500 text-blue-500 bg-blue-50 hover:bg-blue-500 hover:text-white transition duration-300"
        >
          {containers[0]?.buttonText}
        </a>
      )}
    </div>
  );
};

export default ServiceOverview;
